import { palette } from '../../../settings/themes/colors';
import popoverCardStyles from '../popoverCardStyles';

const styles = () => ({
  root: {
    ...popoverCardStyles,
    minWidth: 260,
    maxWidth: 300,
    paddingBottom: 0
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 10,
    marginBottom: 10,
    borderBottom: `1px solid ${palette.platinum}`
  },
  userInfo_texts: {
    marginLeft: 10,
    overflow: 'hidden'
  },
  userInfo_name: {
    fontWeight: 700,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  userInfo_email: {
    fontSize: 12,
    color: palette.dimGray,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  languageRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 0'
  },
  menuItem: {
    padding: '8px 0',
    fontSize: 14,
    justifyContent: 'flex-start',
    width: '100%',
    color: palette.darkGray,
    textTransform: 'capitalize'
  },
  menuItem_selected: {
    color: palette.cerulean
  }
});

export default styles;
